import { Indicator, Root } from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import { Label } from '@avanta/shared/components/ui/Label';
import { cn } from '@avanta/shared/utils/cn';
import { checkboxClasses, checkboxIndicatorClasses, checkboxReadOnlyClasses } from './styles';
import { type CheckboxProps } from './types';

export const Checkbox = ({
  className,
  id,
  label,
  labelClassName,
  required,
  readOnly = false,
  disabled = false,
  children,
  ...props
}: CheckboxProps): React.ReactElement => {
  if (children) {
    return (
      <Root
        id={id}
        data-slot="checkbox"
        required={required}
        disabled={readOnly || disabled}
        data-readonly={readOnly}
        aria-readonly={readOnly}
        className={cn('inline-flex cursor-pointer', readOnly && 'cursor-default', className)}
        {...props}
      >
        {children}
      </Root>
    );
  }

  const checkboxElement = (
    <Root
      id={id}
      data-slot="checkbox"
      required={required}
      disabled={readOnly || disabled}
      data-readonly={readOnly}
      aria-readonly={readOnly}
      className={cn(checkboxClasses, readOnly && checkboxReadOnlyClasses, className)}
      {...props}
    >
      <Indicator data-slot="checkbox-indicator" className={checkboxIndicatorClasses}>
        <CheckIcon className="size-3.5" />
      </Indicator>
    </Root>
  );

  if (!label) return checkboxElement;

  return (
    <div className="flex items-center gap-1">
      {checkboxElement}
      <Label htmlFor={id} required={required} className={cn('font-medium ml-1', labelClassName)}>
        {label}
      </Label>
    </div>
  );
};

export { CheckboxController } from './controller';
export type { CheckboxControllerProps, CheckboxProps } from './types';
